<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Finalizado</th>
          <th>Arquivado</th>
          <th>Glosa</th>
          <th>Situação</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="faturamento in faturamentos" :key="faturamento._id">
          <td>{{ faturamento.nome }}</td>
          <td :class="faturamento.finalizado ? 'text-success' : 'text-danger'">
            {{ faturamento.finalizado ? '' : 'Não' }}
            <span v-if="faturamento.finalizado" class="text-info">
              {{ formatarData(faturamento.finalizado, 'DD/MM/YYYY') }}
            </span>
          </td>
          <td :class="faturamento.arquivado ? 'text-success' : 'text-danger'">
            {{ faturamento.arquivado ? '' : 'Não' }}
            <span v-if="faturamento.arquivado" class="text-info">
              {{ formatarData(faturamento.arquivado, 'DD/MM/YYYY') }}
            </span>
          </td>
          <td :class="faturamento.glosa ? 'text-success' : 'text-danger'">
            {{ faturamento.glosa ? '' : 'Não' }}
            <span v-if="faturamento.glosa" class="text-info">
              {{ formatarData(faturamento.glosa, 'DD/MM/YYYY') }}
            </span>
          </td>
          <td>{{ faturamento.ativo ? 'Ativo' : 'Cancelado' }}</td>
          <td>
            <RouterLink
              id="botaoEditar"
              v-tooltip="'Editar'"
              data-test-id="link-botaoeditar"
              :to="'/faturamento/cadastro/' + faturamento._id"
              name="botaoEditar"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-edit" />
            </RouterLink>
            <button
              v-if="exibeFinalizar(faturamento)"
              id="botaoFinalizar"
              v-tooltip="'Finalizar'"
              data-test-id="button-botaofinalizar"
              type="button"
              name="botaoFinalizar"
              class="btn btn-xs btn-link"
              @click.prevent="finalizar(faturamento)"
            >
              <span class="fa fa-calendar" />
            </button>
            <button
              v-if="exibeArquivar(faturamento)"
              id="botaoArquivar"
              v-tooltip="'Arquivar'"
              data-test-id="button-botaoarquivar"
              type="button"
              name="botaoArquivar"
              class="btn btn-xs btn-link"
              @click.prevent="arquivar(faturamento)"
            >
              <span class="fa fa-folder" />
            </button>
            <button
              v-if="exibeGlosa(faturamento)"
              id="botaoGlosa"
              v-tooltip="'Glosa'"
              data-test-id="button-botaoglosa"
              type="button"
              name="botaoGlosa"
              class="btn btn-xs btn-link"
              @click.prevent="glosa(faturamento)"
            >
              <span class="fa fa-exclamation-circle" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { alertaMixin } from '@/mixins/AlertaMixin'
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'FaturamentoTabela',
  mixins: [alertaMixin],
  props: {
    faturamentos: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...formatadores,
    exibeFinalizar(faturamento) {
      return faturamento.finalizado === null
    },
    exibeArquivar(faturamento) {
      if (faturamento.finalizado !== null && faturamento.arquivado === null) {
        if (faturamento.glosa !== null) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    exibeGlosa(faturamento) {
      if (faturamento.finalizado !== null && faturamento.glosa === null) {
        if (faturamento.arquivado !== null) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    finalizar(faturamento) {
      this.$emit('finalizar', faturamento)
    },
    arquivar(faturamento) {
      this.$emit('arquivar', faturamento)
    },
    glosa(faturamento) {
      this.$emit('glosa', faturamento)
    },
  },
}
</script>
